import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VoyagerequestFormComponent } from './voyagerequest-form.component';
import { VoyagerequestListComponent } from './voyagerequest-list/voyagerequest-list.component';

const routes: Routes = [
  {
    path: '',
    component: VoyagerequestFormComponent
  },
  {
    path: 'list',
    component: VoyagerequestListComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VoyagerequestFormRoutingModule {}